import React, { useState, useEffect, useContext } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { AppContext } from "./ContextVars";
import translations from "./translations";

const BankTransfer = () => { // #added página de seguimiento de Transferencia Bancaria 1/8/26 TG
  const { language } = useContext(AppContext);
  const t = (key) => translations.BankTransfer[key]?.[language] || key;
  const [searchParams] = useSearchParams();
  const order = searchParams.get("order") || "";

  const [loading, setLoading] = useState(true);
  const [orderData, setOrderData] = useState(null);
  const [error, setError] = useState("");
  const [file, setFile] = useState(null);
  const [bankReference, setBankReference] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const [refreshToken, setRefreshToken] = useState(0);

  useEffect(() => {
    if (!order) {
      setError(t("noOrder"));
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch("https://eleven.fit/php/bank-get-order.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ order }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          setOrderData(data.data);
          setError("");
        } else {
          setError(data.message || t("notFound"));
        }
      })
      .catch(() => setError(t("networkError")))
      .finally(() => setLoading(false));
  }, [order, refreshToken]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setSubmitMessage(t("fileRequired"));
      return;
    }
    setSubmitting(true);
    setSubmitMessage("");
    const formData = new FormData();
    formData.append("order", order);
    formData.append("bank_reference", bankReference);
    formData.append("file", file);
    try {
      const res = await fetch("https://eleven.fit/php/bank-submit-proof.php", {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (data.success) {
        setSubmitMessage(t("submitted"));
        setRefreshToken((v) => v + 1);
      } else {
        setSubmitMessage(data.message || t("submitError"));
      }
    } catch (err) {
      setSubmitMessage(t("networkError"));
    }
    setSubmitting(false);
  };

  const formatAmount = (amount) => {
    const num = parseFloat(amount || 0).toFixed(2);
    return orderData && orderData.currency === "GTQ" ? `Q${num}` : `$${num}`;
  };

  const summaryBoxStyle = {
    border: "1px solid rgba(255,255,255,0.3)",
    borderRadius: "8px",
    padding: "20px",
    textAlign: "left",
    background: "rgba(0,0,0,0.25)",
  };

  // #added para que el contenido quede por encima del overlay (tint-black) 1/8/26 TG
  const contentStyle = { position: "relative", zIndex: 1 };

  if (loading) {
    return (
      <section className="section-2 overlay tint-black-40">
        <div className="p-4 max-w-md mx-auto" style={contentStyle}>
          <h2 className="general-h2 margin-top-70">{t("title")}</h2>
          <p className="margin-top-30 font-size-20 color-gray-3">{t("loading")}</p>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="section-2 overlay tint-black-40">
        <div className="p-4 max-w-md mx-auto" style={contentStyle}>
          <h2 className="general-h2 margin-top-70">{t("error")}</h2>
          <p className="margin-top-30 font-size-20 color-gray-3">{error}</p>
          <Link to="/checkout" className="button-2 margin-top-20 margin-bottom-100">{t("goBack")}</Link>
        </div>
      </section>
    );
  }

  const status = orderData?.status;

  return (
    <section className="section-2 overlay tint-black-40">
      <div className="p-4 max-w-md mx-auto" style={contentStyle}>
        <h2 className="general-h2 margin-top-70">{t("title")}</h2>

        <div className="margin-top-30" style={summaryBoxStyle}>
          <p className="font-size-18 color-gray-3">
            <strong>{t("orderNumber")}:</strong> {orderData.order_number}
          </p>
          <p className="font-size-18 color-gray-3">
            <strong>{t("amount")}:</strong> {formatAmount(orderData.amount)}
          </p>
          {orderData.items && orderData.items.length > 0 && (
            <p className="font-size-18 color-gray-3">
              <strong>{t("items")}:</strong>{" "}
              {orderData.items.map((it) => it.name || it.product_id).join(", ")}
            </p>
          )}
        </div>

        {status === "pending_payment" && (
          <div>
            <p className="margin-top-30 font-size-18 color-gray-3">{t("instructions")}</p>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <p className="margin-top-20">{t("uploadProof")}</p>
              <input
                type="file"
                accept="image/png,image/jpeg,image/webp"
                onChange={(e) => setFile(e.target.files[0] || null)}
                className="w-full border mb-2 p-2"
              />
              <p className="margin-top-10">{t("bankReferenceLabel")}</p>
              <input
                type="text"
                placeholder={t("bankReferencePlaceholder")}
                value={bankReference}
                onChange={(e) => setBankReference(e.target.value)}
                className="w-full border mb-2 p-2"
                style={{ color: "#000" }}
              />
              <button className="button-2 margin-top-20 margin-bottom-100" type="submit" disabled={submitting}>
                {submitting ? t("submitting") : t("submit")}
              </button>
            </form>
            {submitMessage && <p className="margin-top-10 font-size-18 color-gray-3">{submitMessage}</p>}
          </div>
        )}

        {status === "pending_approval" && (
          <p className="margin-top-30 font-size-18 color-gray-3 margin-bottom-100">{t("underReviewMessage")}</p>
        )}

        {status === "success" && (
          <div>
            <p className="margin-top-30 font-size-18 color-gray-3">{t("approvedMessage")}</p>
            <Link to="/" className="button-2 margin-top-20 margin-bottom-100">{t("goHome")}</Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default BankTransfer;
